import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import K8DigitalProgramCardV2 from './component'

export const K8DigitalProgramCardV2Container = props => {
  const {
    content,
    contentfulCourses,
    entryId,
    firstTimeMS,
    onComponentClick,
    ...otherProps
  } = props
  const staticLinksAvailable = content?.data?.dashboardProgram?.staticLinks
  const tieredInterventionsLink = staticLinksAvailable?.find(link =>
    //  we acknowledge internalTitle is not the ideal way to retrieve this reference
    link?.internalTitle?.includes('tiered int resources'),
  )

  // FirstTimeClasses ref and handler
  const createCourseRef = useRef(null)

  const createSmallGroupRef = useRef(null)

  // Handle create class button click
  const handleCreateClassClick = () => {
    if (createCourseRef.current) {
      const button = createCourseRef.current.querySelector(
        '[data-testid="button-create"]',
      )
      if (button) {
        button.click()
      }
    }
  }

  const handleCreateSmallGroupClick = () => {
    if (createSmallGroupRef.current) {
      const button = createSmallGroupRef.current.querySelector(
        '[data-testid="button-create-small-group"]',
      )
      if (button) {
        button.click()
      }
    }
  }
  // Determine if we should show FirstTimeClasses
  const showFirstTimeClasses = firstTimeMS && entryId

  // Handle training click - check URL for grade level and redirect accordingly
  const onTrainingClick = () => {
    const url = window.location.href

    // Check if the URL contains grade level indicators
    if (url.includes('k-5') || url.includes('k5')) {
      onComponentClick('/product/elementary/trainings')
    } else if (url.includes('6-8') || url.includes('68')) {
      onComponentClick('/product/middle-school/trainings')
    } else {
      // Fallback - just log that no grade level was found
      console.warn('No grade level found in URL for training redirect:', url)
    }
  }

  // Handle Tier 2 Resources click
  const onTier2ResourcesClick = () => {
    if (tieredInterventionsLink) {
      onComponentClick(tieredInterventionsLink.path)
    } else {
      console.warn('no tiered interventions link returned from content-service')
    }
  }

  return (
    <K8DigitalProgramCardV2
      {...otherProps}
      contentfulCourses={contentfulCourses}
      createCourseRef={createCourseRef}
      createSmallGroupRef={createSmallGroupRef}
      handleCreateClassClick={handleCreateClassClick}
      handleCreateSmallGroupClick={handleCreateSmallGroupClick}
      onComponentClick={onComponentClick}
      onTier2ResourcesClick={onTier2ResourcesClick}
      onTrainingClick={onTrainingClick}
      showFirstTimeClasses={showFirstTimeClasses}
      tier2ResourcesLabel={tieredInterventionsLink?.displayTitle}
    />
  )
}

K8DigitalProgramCardV2Container.propTypes = {
  content: PropTypes.object,
  contentfulCourses: PropTypes.array,
  entryId: PropTypes.string,
  firstTimeMS: PropTypes.bool,
  onComponentClick: PropTypes.func,
}

export default K8DigitalProgramCardV2Container
